import type { ReactNode, CSSProperties } from 'react';

type ChipVariant = 'default' | 'primary' | 'second' | 'third' | 'good' | 'warn';

interface Props {
  variant?: ChipVariant;
  onClick?: () => void;
  children: ReactNode;
  style?: CSSProperties;
  title?: string;
}

export default function Chip({ variant = 'default', onClick, children, style, title }: Props) {
  const cls = variant === 'default' ? 'chip' : `chip ${variant}`;
  return (
    <span
      className={cls}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : undefined, ...style }}
      title={title}
    >
      {children}
    </span>
  );
}

/**
 * Map an application stage to the chip variant. Shared across tables so the
 * color story stays consistent (Interview = primary/green, Applied = second/amber,
 * Evaluated = neutral, Offer = good, Rejected/Discarded = muted).
 */
export function stageVariant(stage: string): ChipVariant {
  switch (stage) {
    case 'Interview':
    case 'Phone screen':
      return 'primary';
    case 'Offer':
      return 'good';
    case 'Applied':
    case 'Responded':
      return 'second';
    case 'Rejected':
    case 'Discarded':
      return 'warn';
    case 'Evaluated':
    default:
      return 'third';
  }
}

export function fitVariant(fit: string): ChipVariant {
  return fit === 'Primary' ? 'primary' : fit === 'Secondary' ? 'second' : 'third';
}
